import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, Button, Snackbar, Alert  } from '@mui/material';
import { TbLoader } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
import { MdOutlineRefresh } from "react-icons/md";

const useStyles = makeStyles((theme)=>({
  main: {
    
  },
  box:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  h1SearchDiv:{
    padding:'40px 0px 20px 0',
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between'
  },
  contConfigBlockH1:{
    fontWeight:'700',
    fontSize:'22px',
    display: 'flex'
  },
  datagridBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'scroll',
    overflowY: 'hidden',
    border: '1px solid #D3D3D3',
  },
  datagridTop: {
    display: 'flex',
    alignItems: 'center',
  },
  datagridTopItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #D3D3D3',
    borderTop:'none',
    padding:'5px 0'
  },
  contBox: {
    display: 'flex',
    alignItems: 'center',
  },
  contBoxItem: {
    textAlign:'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textLeft: {
    width: '100%', 
    height: '100%', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  load:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  loadingIcon:{
    color:'#007235',
    fontSize:'50px',
    animation:'$loadSpin 5s infinite'
  },
  "@keyframes loadSpin":{
    from: { transform:'rotate(0deg)' },
    to: { transform:'rotate(1turn)' }
  },
  contentAddDiv:{
    paddingTop:'20px'
  },

}));

const ContConfig = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  let navigate = useNavigate();
  const row = [
    {name: 'ID', width: '20%'},
    {name: '제목', width: '60%'},
    {name: '관리', width: '20%'},
  ];
  const [data, setData] = useState([])

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const [loading, setLoading] = useState(false)

  const getContItems = async() => {
    try {
      setLoading(true)

      const res = await axios.get('/api/adm/content/')

      if(res.data.success === false) {
        setErrSnack(true)
        setLoading(false)
        return ;
      }

      setData(res.data.result.reduce((result, item) => [
        ...result, 
        [{id: item['co_id'], data: item['co_id'], type: 'textLeft'},
        {id: item['co_id'], data: item['co_subject'], type: 'textLeft'},
        {id: item['co_id'], data: ['수정', '삭제'], type: 'button'}]
      ], []))
      setLoading(false)
  
    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }
  }

  const delItem = async(delId) => {
    try {
      const res = await axios.post('/api/adm/deleteContent/', {co_id: delId} )

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return ;
      }
      setSuccSnack(true)
      getContItems()
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getContItems()

    return () => {
      setData([])
    }
  }, [])


  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };

  return (
    <div className={classes.contConfigBlock}>
      <div className={classes.box}>
        <div className={classes.h1SearchDiv}>
          <h1 className={classes.contConfigBlockH1}>
            내용관리
            <div
                onClick={() => {
                  getContItems()
                }}
              style={{cursor:'pointer'}}
            >
              <MdOutlineRefresh/>
            </div>
          </h1>
          <div>
              <Button 
                variant="text" 
                onClick={() => {
                  navigate("/DashboardMain/contAdd");
                }}
                style={{ background:'#007235', color:'#fff'}}
              >
                내용추가
              </Button>
          </div>
        </div>
        <div className={classes.datagridBox}>
          <div className={classes.datagridTop}>
  
            {row.map((item, index) => (
                      <div 
                        key={index} 
                        className={classes.datagridTopItem} 
                        style={{width: item.width}}
                      >
                        {item.name}
                      </div>
            ))}
          </div>
  
          {loading ? (
            <div className={classes.load}>
              <TbLoader className={classes.loadingIcon}/>
            </div>
          ) :
          data.length > 0 && data.map((dataItem, dataIndex) => {
            return(
                    <div 
                      key={dataIndex} 
                      className={classes.contBox}
                      style={{ backgroundColor: dataIndex % 2 == 0 && '#F2F2F2' }}
                    >
  
                        {dataItem.map((item, index) => {
                          return(
                                <div 
                                  key={index} 
                                  className={classes.contBoxItem} 
                                  style={{
                                    width: row[index].width,
                                    
                                  }}
                                >
                                  {item.type === 'textLeft' && (
                                    <h3 className={classes.textLeft}>{item.data}</h3>
                                  )}
                                  {item.type === 'button' && 
                                    (
                                      <div>
                                        {item.data.map((btnItm, btnIdx) => (
                                        <Button 
                                          key={btnIdx} 
                                          variant="text" 
                                          style={{ minWidth:0 }}
                                          onClick={() => {
                                            btnItm === '삭제' && delItem(item.id)
                                            btnItm === '수정' && navigate("/DashboardMain/contEdit", {
                                                                            state: { poId: item.id }
                                                                          })
                                          }}
                                        >
                                          {btnItm}
                                        </Button>
                                        ))}
                                      </div>
                                    )
                                  }
  
                                </div>
                        )})}
                    </div>
          )})}
  
        </div>
      </div>

      <div className={classes.box}>
        <div className={classes.contentAddDiv}>
          <Button 
            variant="text" 
            onClick={() => {
              navigate("/DashboardMain/contAdd");
            }}
            style={{ background:'#007235', color:'#fff'}}
          >
            내용추가
          </Button>
        </div>
      </div>

      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 

    </div>
  )
}

export default ContConfig
